import { useState } from "react";

import { useChooseEntityVariant } from "../choose-entity-variant-context";
import VersionContent from "../VersionContent";

import useReleaseLabels from "./hooks/useReleaseLabels";
import ReleaseLabelsContent from "./ReleaseLabelsContent";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const LabelVersionView = ({
  latestVersion,
  readonly = false,
  onVersionSelect,
  onLabelSelect,
  onTabChange,
}: {
  latestVersion?: number;
  readonly?: boolean;
  onVersionSelect?: (version?: number) => void;
  onLabelSelect?: (labelName: string) => void;
  onTabChange?: (tab: string) => void;
}) => {
  const { entity } = useChooseEntityVariant();
  const [selectedVersion, setSelectedVersion] = useState<number | undefined | null>(null);
  const [selectedLabel, setSelectedLabel] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("versions");

  const {
    labels,
    isLoading: labelsLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useReleaseLabels(entity);

  const handleVersionSelect = (version?: number) => {
    setSelectedVersion(version);
    setSelectedLabel(null);
    onVersionSelect?.(version);
  };

  const handleLabelSelect = (labelName: string) => {
    setSelectedLabel(labelName);
    setSelectedVersion(null);
    onLabelSelect?.(labelName);
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setSelectedVersion(null);
    setSelectedLabel(null);
    onTabChange?.(tab);
  };

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange} className="flex h-full flex-col">
      <div className="flex-shrink-0 px-6 pt-4">
        <TabsList>
          <TabsTrigger value="versions">Versions</TabsTrigger>
          <TabsTrigger value="labels">Release Labels</TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="versions" className="m-0 min-h-0 flex-1">
        <VersionContent
          isLoading={false}
          latestVersion={latestVersion}
          selectedVersion={selectedVersion}
          readonly={readonly}
          onVersionSelect={handleVersionSelect}
        />
      </TabsContent>
      <TabsContent value="labels" className="m-0 min-h-0 flex-1">
        <ReleaseLabelsContent
          isLoading={labelsLoading}
          labels={labels}
          selectedLabel={selectedLabel}
          readonly={readonly}
          onLabelSelect={handleLabelSelect}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
        />
      </TabsContent>
    </Tabs>
  );
};

export default LabelVersionView;
